import Cookies from "js-cookie";

var newsletter_cookie = Cookies.get("newsletter_seen");
setTimeout(() => {
    if (!newsletter_cookie) {
        let newsletter_element = document.getElementById("newsletter");
        if (newsletter_element) {
            newsletter_element.classList.add("active");
        }
    }
    }, 6000);
//}, 200);
document.addEventListener("DOMContentLoaded", function () {
    const newsletter_close = document.getElementById("newsletter-close-button");
    const newsletter_open = document.getElementById("newsletter-button");
    const newsletter = document.getElementById("newsletter");

    if (newsletter_close && newsletter) {
        newsletter_close.onclick = function (event) {
            event.preventDefault();
            event.stopPropagation();
            newsletter.classList.remove("active");
            Cookies.set("newsletter_seen", 1, { expires: 200 });
        };
    }

    if (newsletter_open && newsletter) {
        newsletter_open.onclick = function (event) {
            event.preventDefault();
            event.stopPropagation();
            newsletter.classList.add("active");
        };
    }
});